import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { IonText } from '@ionic/react'

import StatusTile from './StatusTile'
import TripQuestionnaireResponse from './TripQuestionnaireResponse'
import { formatUTCAsLocalTime, groupTripQuestionResponses } from 'utils'
import * as Types from 'types'

const { TRIP_QUESTION_SECTION } = Types

const propTypes = {
  workOrder: Types.workOrder.isRequired,
  trip: Types.trip.isRequired,
  selectImage: PropTypes.func.isRequired,
}

const defaultProps = {}

function TripPreview({ workOrder, trip, selectImage }) {
  const { createdAt, notes, abuseNeglectClaims, operable, rootCause, status } =
    trip
  const abuseDefectHeaderText = Types.ROOT_CAUSE_NEGLECT_OPTIONS.includes(
    rootCause
  )
    ? 'Abuse'
    : 'Defect'

  const grouped = groupTripQuestionResponses(trip.allQuestionResponses)
  const checkInQuestions = [
    ...grouped[TRIP_QUESTION_SECTION.CHECK_IN_STANDARD],
    ...grouped[TRIP_QUESTION_SECTION.CHECK_IN_CUSTOM],
  ]
  const checkOutStandardQuestions =
    grouped[TRIP_QUESTION_SECTION.CHECK_OUT_STANDARD]
  const checkOutCustomQuestions =
    grouped[TRIP_QUESTION_SECTION.CHECK_OUT_CUSTOM]

  return (
    <div className="trip-preview-container">
      <div className="flex">
        <IonText
          color="tss-grey-dark"
          className="body-small mr-auto flex align-center"
        >
          <span>{workOrder.name}</span>
        </IonText>
        <StatusTile status={status} />
      </div>

      <hr />

      <h4 className="m-t-8">Checked In</h4>
      <p>{formatUTCAsLocalTime(createdAt)}</p>

      {/*
        Every section renders for every trip, whatever its status. Photos sync
        to Salesforce the moment they are uploaded, so a trip that was never
        checked out (closed no checkout, expired, or stalled on site) can still
        hold check-in photos and even checkout-phase photos.
      */}
      {checkInQuestions.length > 0 && (
        <>
          <h3 className="trip-preview-section">Check In Questions</h3>
          <TripQuestionnaireResponse
            questions={checkInQuestions}
            selectImage={selectImage}
          />
        </>
      )}

      <h3 className="trip-preview-section">Standard Checkout Questions</h3>
      <h4>Notes</h4>
      <p>{notes}</p>
      {(Types.ROOT_CAUSE_NEGLECT_OPTIONS.includes(rootCause) ||
        rootCause == Types.ROOT_CAUSE_DEFECT) && (
        <>
          <h4>{abuseDefectHeaderText} Notes</h4>
          <p>{abuseNeglectClaims}</p>
        </>
      )}

      <h4>Root Cause</h4>
      <p>{rootCause}</p>

      <h4>Operational?</h4>
      <p>{operable}</p>

      <TripQuestionnaireResponse
        questions={checkOutStandardQuestions}
        selectImage={selectImage}
      />

      {checkOutCustomQuestions.length > 0 && (
        <>
          <h3 className="trip-preview-section">
            Custom Check Out Questions
          </h3>
          <TripQuestionnaireResponse
            questions={checkOutCustomQuestions}
            selectImage={selectImage}
          />
        </>
      )}
    </div>
  )
}
TripPreview.propTypes = exact(propTypes)
TripPreview.defaultProps = defaultProps

export default React.memo(TripPreview)
